import React, { useContext } from "react";
import { ReadingReportContrext } from "../ReadingReportsTable";
import CommonArows from "../../../CommonArows";
import { useOutletContext } from "react-router-dom";

function PinThreeHeaderStyle() {
  const context = useContext(ReadingReportContrext);
  const {
    deviceList,
    pageSize,
    pageind,
    GetList,
    setIsChecked,
    SetCheckedArray,
    isChecked,
    CheckedArray,
    isAlert,
    AlphabetType,
    isTime,
    Values,
    ChangeOrderType,
    OBJKeys,
    communicationfailvalue,
  } = context || {};
  const outletcontext: any = useOutletContext();
  const { PinList } = outletcontext || {};

  return (
    <>
      <th rowSpan={2}>
        <CommonArows
          margintop={20}
          Show="both"
          Headername={PinList[2]?.pin_name ? PinList[2]?.pin_name : "Pin 3"}
          handleAscending={() => {
            GetList &&
              GetList(
                1,
                30,
                Values,
                false,
                false,
                "pin_3_status",
                "asc",
                isChecked?.pin_1_status,
                isChecked?.pin_2_status,
                isChecked?.pin_3_status,

                isAlert,
                isTime,
                communicationfailvalue
              );
            ChangeOrderType && ChangeOrderType("pin_3_status", "asc");
          }}
          handleDescending={() => {
            GetList &&
              GetList(
                1,
                30,
                Values,
                false,
                false,
                "pin_3_status",
                "desc",
                isChecked?.pin_1_status,
                isChecked?.pin_2_status,
                isChecked?.pin_3_status,

                isAlert,
                isTime,
                communicationfailvalue
              );
            ChangeOrderType && ChangeOrderType("pin_3_status", "desc");
          }}
          handleFilter={() => {
            setIsChecked &&
              setIsChecked((pre: any) => {
                return {
                  ...pre,
                  pin_3_status: true,
                };
              });

            GetList &&
              GetList(
                1,
                30,
                Values,
                false,
                false,
                AlphabetType?.OrderBy,
                AlphabetType?.Order,
                isChecked?.pin_1_status,
                isChecked?.pin_2_status,
                !isChecked?.pin_3_status ? true : false,

                isAlert,
                isTime,
                communicationfailvalue
              );
            if (!isChecked?.pin_3_status) {
              SetCheckedArray &&
                SetCheckedArray((pre: any) => {
                  return [...pre, "pin_3_status"];
                });
            } else {
              const data = CheckedArray.filter((ele: any) => {
                return ele !== "pin_3_status";
              });
              SetCheckedArray && SetCheckedArray(data);
              setIsChecked &&
                setIsChecked((pre: any) => {
                  return {
                    ...pre,
                    pin_3_status: false,
                  };
                });
            }
          }}
          isChecked={isChecked?.pin_3_status}
          CheckedArray={CheckedArray}
          type="pin_3_status"
          StatusType="ON"
        />
      </th>
    </>
  );
}

export default PinThreeHeaderStyle;
